import {pageInfo, delayCarrierInfo} from './../api';
const delay = {
  namespaced: true,
  state: {
    pageResp:null,
    carrierDelayInfo:null
  },
  mutations: {

    PAGE_INFO(state,data){
      state.pageResp = data.obj || [];
    },
    DELAY_CARRIER_INFO(state,data){
      state.carrierDelayInfo = data.obj || [];
    },
  },
  actions: {
    //查询事件(延迟原因总汇总)
    async delayInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //查询事件(延迟原因总汇总)
    async delayCarrierInfo({commit}, obj){
      let resp = await delayCarrierInfo(obj);
      commit('DELAY_CARRIER_INFO', resp);
    }
  }
}
export default delay



// WEBPACK FOOTER //
// ./src/page/report/delay/store/delay.store.js